import React from 'react';
import './Header.css';
import githubIcon from '../assets/icons/github-icon.png';
import linkedinIcon from '../assets/icons/linkedin-icon.png';
import { useTheme } from '../context/ThemeContext';

const Header = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="header">
      <div className="header-name">
        <h1>
          <a href="/" className="name-link">Evyatar Cohen</a>
        </h1>
      </div>
      <div className="header-tagline">
        <p>Developer. Game Designer. Maker.</p>
      </div>
      <div className="header-right">
        <div className="icon-container">
          <a href="/about" className="about-link">About</a>
        </div>
        <div className="icon-container">
          <a href="https://github.com/CaptainGradius" target="_blank" rel="noopener noreferrer">
            <img src={githubIcon} alt="GitHub" className="icon" />
          </a>
        </div>
        <div className="icon-container">
          <a href="https://linkedin.com/in/evyatareladcohen" target="_blank" rel="noopener noreferrer">
            <img src={linkedinIcon} alt="Linkedin" className="icon" />
          </a>
        </div>
        <div className="icon-container">
          <button
            type="button"
            onClick={toggleTheme}
            className="theme-toggle"
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? (
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="4" />
                <line x1="12" y1="1" x2="12" y2="3" />
                <line x1="12" y1="21" x2="12" y2="23" />
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                <line x1="1" y1="12" x2="3" y2="12" />
                <line x1="21" y1="12" x2="23" y2="12" />
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
              </svg>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
